module.exports = __webpack_public_path__ + "e670069cc7211ff43e6aa29a0bfe6a3c.png";